import { useLang } from "@/context/AppContext";

export const STATE_STYLE = {
  proposed: "text-amber-300 border-amber-400/40 bg-amber-400/10",
  confirmed: "text-cyan-300 border-cyan-400/40 bg-cyan-400/10",
  authorized: "text-yellow-300 border-yellow-400/40 bg-yellow-400/10",
  active: "text-emerald-300 border-emerald-400/40 bg-emerald-400/10",
  completed: "text-slate-300 border-slate-400/40 bg-slate-400/10",
  suspended: "text-orange-300 border-orange-400/40 bg-orange-400/10",
  terminated: "text-rose-300 border-rose-400/40 bg-rose-400/10",
};

export const StateBadge = ({ state, testId = "relationship-state-badge" }) => {
  const { t } = useLang();
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 font-mono text-[11px] uppercase tracking-widest ${STATE_STYLE[state] || ""}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {t(`st_${state}`)}
    </span>
  );
};

const FLOW = ["proposed", "confirmed", "authorized", "active", "completed"];

export const Stepper = ({ state }) => {
  const { t } = useLang();
  const idx = FLOW.indexOf(state);
  return (
    <ol className="flex flex-wrap items-center gap-2" data-testid="state-stepper">
      {FLOW.map((s, i) => {
        const done = idx >= i;
        return (
          <li key={s} className="flex items-center gap-2">
            <span className={`rounded-md border px-3 py-1.5 font-mono text-[11px] uppercase tracking-widest transition-colors duration-300 ${done ? STATE_STYLE[s] : "border-white/10 text-slate-500"} ${s === state ? "ring-1 ring-current" : ""}`}>
              {t(`st_${s}`)}
            </span>
            {i < FLOW.length - 1 && <span className={`h-px w-6 ${idx > i ? "bg-emerald-400/60" : "bg-white/10"}`} />}
          </li>
        );
      })}
      {(state === "suspended" || state === "terminated") && <StateBadge state={state} testId="stepper-exception-state" />}
    </ol>
  );
};
